import { createAction, props } from '@ngrx/store';
import { User } from '../../../shared/models';
import { Applicant } from '../../../shared/models/Applicant';

export const LoginApplicant = createAction(
  '[Shared][Authentication] Login Applicant',
  props<{ data: { token: string, expiresAt: Date, applicant: Applicant } }>()
);

export const LoggedInApplicant = createAction(
  '[Shared][Authentication] Logged In Applicant',
  props<{ data: { token: string, expiresAt: string } }>()
);

export const LoggedInSuccessApplicant = createAction(
  '[Shared][Authentication] Logged In Applicant Success',
  props<{ data: { applicant: Applicant, token: string, expiresAt: string } }>()
);

export const LoginUser = createAction(
  '[Shared][Authentication] Login User',
  props<{ data: { token: string, expiresAt: Date, user: User } }>()
);

//export const GetUserRole = createAction(
//  '[Shared][Authentication] Get User Role',
//  props<{ user: User }>()
//);

//export const GetUserRoleSuccess = createAction(
//  '[Shared][Authentication] Get User Role Success',
//  props<{ userRoles: UserRole[] }>()
//);

export const LogoutApplicant = createAction(
  '[Shared][Authentication] Logout Applicant',
);

export const LogoutApplicantSuccess = createAction(
  '[Shared][Authentication] Logout Applicant Success',
);

export const LoggedInUser = createAction(
  '[Shared][Authentication] Logged In User',
  props<{ data: { token: string, expiresAt: string } }>()
);

export const LoggedInSuccessUser = createAction(
  '[Shared][Authentication] Logged In User Success',
  props<{ data: { user: User, token: string, expiresAt: string } }>()
);

export const LogoutUser = createAction(
  '[Shared][Authentication] Logout User',
);

export const LogoutUserSuccess = createAction(
  '[Shared][Authentication] Logout User Success',
);

